import { List } from 'antd';
import { useNavigate } from 'react-router';

import NextIcon from '@asset/next.icon.svg?react';
import { RouteEnum } from '@enum/route.enum';
import { getTestId } from '@util/data/get-test-id';
import { isString } from '@util/data/is-exist';

import { StartupList } from './application-setup-next.options';
import {
  Description,
  DividerList,
  ItemTitle,
  ListWrapper,
  NextList,
  Title,
  Wrapper,
} from './application-setup-next.style';

export const ApplicationSetupNextPage = () => {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Title level={2} weight={400}>
        Get Started
      </Title>
      <Description>What do you want to do next?</Description>
      <DividerList />
      <ListWrapper>
        <NextList
          dataSource={StartupList}
          itemLayout='horizontal'
          renderItem={({ Icon, title, link, href, testId }) => (
            <List.Item
              onClick={() => {
                if (isString(link)) return navigate(link);
                if (isString(href)) return window.open(href, '_blank');

                navigate(RouteEnum.Dashboard.path);
              }}
              {...getTestId(testId)}
            >
              <List.Item.Meta
                avatar={<Icon />}
                // description={description}
                title={<ItemTitle level={5}>{title}</ItemTitle>}
              />
              <NextIcon />
            </List.Item>
          )}
        />
      </ListWrapper>
    </Wrapper>
  );
};
